export default __webpack_public_path__ + "static/media/vote_proxy_4.78a2dce0.jpg";